export default "__VITE_ASSET__CkocVSqJ__"